module.exports = __webpack_public_path__ + "img/clip-marriage-proposal.f3f3adfc.png";